import SignupForm from '../components/SignupForm'

export default function Signup() {
  return <SignupForm />
}
